






import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
const colors: Object = {
    'yellow': '#FFB83A',
    'violet': '#6E478F',
    'darkgray': '#586174',
    'lightgray': '#A29CA5',
    'gray': '#E2E2E2',
    'white': '#FFFFFF'
}
const validatorColors = function(value: string) {
    return value in colors;
};
@Component
export default class IconButtonComponent extends Vue {
    @Prop({required: true}) icon: string;
    @Prop({validator: validatorColors, default: 'darkgray'}) fill: string;
    @Prop({validator: validatorColors, default: 'gray'}) color: string;
    get hrefIcon(): string {
        return `/assets/img/svg-sprite.svg#${this.icon}`
    }
    getHtmlColor(color: string): string {
        return (colors as any)[color];
    }
}
